module.exports = __webpack_public_path__ + "static/img/loading.0ee7a51.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loading.jpeg
// module id = Vk40
// module chunks = 1